import PropTypes from 'prop-types'
import classNames from 'classnames'

import Typography from '../../typography'
import SuggestionCall from '../suggestion/call'

import { useBreakpoint } from '../../../../hooks/breakpoint'
import { useAuth } from '../../../../hooks/auth'

import BannuBannerBg from '../../../../public/img/bantrab/decoration-bannu-outline-1.svg.svg'

const Suggestion = ({ title, form, pageId, ...attrs }) => {
  const { setSuggestionSent } = useAuth()
  const breakpoint = useBreakpoint()

  attrs.className = classNames(
    attrs.className,
    [
      'relative',
      'py-6',
      'md:py-20',
      'bg-red-500'
    ]
  )

  return <section {...attrs}>
    <div
      className={
        classNames([
          breakpoint.mdAndUp ? '' : 'relative',
          'relative',
          'container',
          'px-4',
          'flex',
          'flex-col',
          'items-center',
          'justify-center'
        ])
      }>
      <div
        className={'w-full text-center'}
        style={{
          maxWidth: '38rem'
        }}>
        {
          title
            ? <Typography
              size={breakpoint.mdAndUp ? 'seven' : 'five'}
              weight={'black'}
              className={'text-white mb-6'}>
              {title}
            </Typography>
            : null
        }
        {
          form
            ? <SuggestionCall
              form={form}
              pageId={pageId}
              submitSuccessCallback={() => setSuggestionSent(true)}
              className={'w-full md:w-4/5 mx-auto'} />
            : null
        }
      </div>
    </div>
  </section>
}

Suggestion.propTypes = {
  form: PropTypes.object,
  title: PropTypes.string,
  pageId: PropTypes.number
}

export default Suggestion
